import { createAsyncThunk } from '@reduxjs/toolkit'
import { shouldLogOutBasedOnHttpResponseStatus } from 'src/consumer/helpers/utilFunctions'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'
import { getData } from 'src/consumer/services/profileService'
import { normalizeProfileData } from '../normalizeProfileData'

let inFlightProfileRequest = null

export const getProfileData = createAsyncThunk(
  'profile/getData',
  async ({ navigate, _forceRefresh = false }, { rejectWithValue, getState }) => {
    getProfileData.pending()
    const { profileDataStore } = getState()
    const currentProfileData = normalizeProfileData(profileDataStore?.profileData?.data)

    if (!!currentProfileData && !_forceRefresh) {
      return currentProfileData
    }

    if (!_forceRefresh && inFlightProfileRequest) {
      return inFlightProfileRequest
    }

    inFlightProfileRequest = (async () => {
      const resp = await getData('/api/secure/user/profile')

      if (resp?.status === 200) {
        const normalizedProfileData = normalizeProfileData(resp)
        localStorage.setItem('authorities', JSON.stringify(normalizedProfileData?.authorities))
        return normalizedProfileData
      } else if (shouldLogOutBasedOnHttpResponseStatus(resp?.response?.status)) {
        const redirectURI = encodeURIComponent(window.location.href)
        if (window.location.pathname.split('/').includes('chamber-screen-home')) {
          logoutHandler(['ROLE_CA_CONFIG', 'ROLE_SCREEN_CONFIG'], [])
        } else {
          logoutHandler([], ['autoNavigatedToEmrOnceInSession'])
        }
        navigate(`/?redirect=${redirectURI}`)
        return rejectWithValue('Unauthorized access')
      }

      return rejectWithValue(resp?.message || 'Failed to fetch profile data')
    })()

    try {
      return await inFlightProfileRequest
    } finally {
      inFlightProfileRequest = null
    }
  }
)
